import { DebouncedInputField } from "@/components/DebouncedInputField";
import { type QuestionsProps } from "@/features/questionnaire/types";

export const FreeTextQuestion = ({
  answer,
  onFreeTextAnswered,
}: QuestionsProps) => {
  return (
    <DebouncedInputField
      value={answer?.answerFreeText ?? undefined}
      onChange={(e) => {
        onFreeTextAnswered?.(e);
      }}
    />
  );
};
